module.exports = __webpack_public_path__ + "static/pet-ff4dd3d682741c20a84e53c8a1824228.png";